import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import CredentialProviderSelectorStep from '../../steps/CredentialProviderSelectorStep';

export default function buildCredentialProviderSelectorConfiguration({
  selectedProvider,
  setSelectedProvider,
}) {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.CREDENTIAL_PROVIDER_SELECTOR,
    title: 'Selecciona tu facturador',
    tooltipTitle:
      'Según el facturador que utilices, te ofreceremos las opciones disponibles para ceder tus facturas.',
    component: CredentialProviderSelectorStep,
    props: {
      selectedProvider,
      setSelectedProvider,
    },
  };
}
